<div class="infoPanel apptBookerComponent">
    <div class="field" style="flex-basis: 48%;">
        <div class="field-label">Date/Time</div>
        <dx-date-box class="field-item" [value]="aptTime" displayFormat="EEE d MMM yyyy HH:mm" type="datetime"
            [disabledDates]="disabledDates" [disabled]="disableDateTime" [openOnFieldClick]="true"
            (onValueChanged)="valueChanged($event)" width="250px"  dateSerializationFormat="yyyy-MM-ddTHH:mm:ssZ" 
            [acceptCustomValue]="false">            
        </dx-date-box>        
        <dx-button hint="Session delay times" width="120" height="36" (onClick)="SessionDelays($event)" [disabled]="DisableSessionDelayEditing">  
            <div style="font-size: x-small;">
                Pre : {{PreSessionDelay}} Mins
                <br />
                Post : {{PostSessionDelay}} Mins
            </div>
        </dx-button>
    </div>
    <div style="flex-basis: 13%;">
        <div style="font-weight: bold;" class="field-label" [innerHTML]="AptStateDesc"></div>
    </div>
    <div *ngIf="aptLocked === true">
        <i class="material-icons" title="Appointment is locked">lock</i>
    </div> 
    <div
        style="flex-basis: 34%; display:flex; flex-direction: row; align-items:flex-end; justify-content: flex-end; align-content: flex-end;">
        <dx-button class="apptBookerButton" text="Attend" hint="Mark appointment as attended" width="118"
            *ngIf="ShowAttend" (onClick)="btnAttendApt($event)"></dx-button>
        &nbsp;
        <dx-button class="apptBookerButton" text="Cancel" hint="Cancel Appointment" width="118" *ngIf="ShowCancel"
            (onClick)="btnCancelApt($event)"></dx-button>
    </div>
    <app-edit-session-delays (CloseDlg)="SessionDelaysClosed($event)"></app-edit-session-delays>
</div>